/* Requestolizer.js */

'use strict';
const _ = require('lodash');

class Requestolizer {
  constructor(socket, api, service) {
    _.forEach(api, (definition, name) => {
      let methodName = definition.method || name;
      this[methodName] = (request, cb) => {
        return new Promise((resolve, reject) => {
          if (!_.isObject(request)) {
            throw new Error('request must be an object with some keys, yo!');
          }

          let plainCbObject = {
            Success: () => {},
            Failure: () => {},
            Progress: () => {},
          };

          if (cb && _.isPlainObject(cb)) {
            cb = _.defaults(cb, plainCbObject);
          } else {
            cb = plainCbObject;
          }

          let message = {};
          message.service = service;
          message.method = methodName;
          message.payload = request;

          let _handleSuccessResponse = function (data, requestHandlers) {
            //make sure we are working with objects...
            if (_.isObject(requestHandlers) && _.isFunction(requestHandlers.Success)) {
              requestHandlers.Success(data);
              resolve(data);
            }
          };
          let _handleProgressResponse = function (data, requestHandlers) {
            //make sure we are working with objects...
            if (_.isObject(requestHandlers) && _.isFunction(requestHandlers.Progress)) {
              requestHandlers.Progress(data);
            }
          };
          let _handleErrorResponse = function (errorObj, requestHandlers) {
            //make sure we are working with objects...
            if (_.isObject(requestHandlers) && _.isObject(errorObj)) {
              let functionToCall;

              let ec = _.get(errorObj.error, 'errorCode');
              if (Object.hasOwn(requestHandlers, ec)) {
                functionToCall = requestHandlers[ec];
              }

              //If no glue error or specialized handler try the catch all error callback "Failure"
              if (!_.isFunction(functionToCall) && Object.hasOwn(requestHandlers, 'Failure')) {
                functionToCall = requestHandlers.Failure;
              }

              //Call the appropriate error callback
              if (_.isFunction(functionToCall)) {
                functionToCall(errorObj);
                reject(errorObj);
              }
            }
          };

          socket.emit('request', message, (response) => {
            let responseHandler = (data) => {
              if (data.error) {
                _handleErrorResponse(data, cb);
              } else {
                if (data.complete) {
                  socket.removeListener(responseHandler);
                  _handleSuccessResponse(response.payload, cb);
                } else {
                  _handleProgressResponse(data.payload, cb);
                }
              }
            };

            if (!response.complete) {
              socket.on(response.responseEvent, responseHandler);
            } else {
              //sync response
              if (response.error) {
                _handleErrorResponse(response, cb);
              } else {
                _handleSuccessResponse(response.payload, cb);
              }
            }
          });
        });
      };
    });
  }
}

module.exports = Requestolizer;
